import React, { forwardRef } from 'react';

import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { ContainerCard, CardBody, CardHeader } from './styles';

export function DefaultLoadingBodyComponent({ linesCount = 4, perLine = 2 }) {
  return (
    <SkeletonTheme>
      {new Array(linesCount).fill(0).map((_, index) => (
        <p>
          <Skeleton count={perLine} />
        </p>
      ))}
    </SkeletonTheme>
  );
}

export function DefaultLoadingHeaderComponent() {
  return (
    <div className="mx-5 pt-5 mb-3">
      <Skeleton height={80} />
    </div>
  );
}

function Card(
  {
    header,
    loading,
    children,
    HeaderRightComponent,
    LoadingBodyComponent = DefaultLoadingBodyComponent,
    LoadingHeaderComponent = DefaultLoadingHeaderComponent,
  },
  ref
) {
  return (
    <ContainerCard className="mb-3" ref={ref}>
      {header && (
        <>
          {loading ? (
            <LoadingHeaderComponent />
          ) : (
            <CardHeader>
              {header}
              {HeaderRightComponent}
            </CardHeader>
          )}
        </>
      )}
      <CardBody>{loading ? <LoadingBodyComponent /> : children}</CardBody>
    </ContainerCard>
  );
}

export default forwardRef(Card);
